export default __webpack_public_path__ + "static/banner-02-1fded450b4c92ec97dd431fff3af81e5.png";